<template>
  <div class="wallet-takt-header color-4 t-rounded t-shadow font-weight-light">
    <div
      class="wallet-takt-header-statistic-button ml-1"
      v-if="$vuetify.breakpoint.smAndDown && !getUseOnSite"
    >
      <slot name="settings-button"/>
    </div>

    <slot :takt_time="takt_time">
        <!-- NAVIGATE LEFT -->
      <button
        v-if="$vuetify.breakpoint.smAndDown"
        class="wallet-takt-header-navigation-button"
        v-ripple
        @click.prevent.stop="$router.push({
          name: 'ProjectWalletTakt',
          params: {
            takt_index: parseInt($route.params.takt_index) - parseInt(1),
            direction: 'left'
          }
        })"
      >
        <TIcon name="chevron-left" large />
      </button>

      <TText v-if="show_calendar_weeks && takt_time" :size="15" :font_weight="isInTaktTime?'500':'300'" :text="` CW
        ${ takt_time.calendar_weeks[0] }
        ${ takt_time.calendar_weeks.length > 1
          ? ` - ${takt_time.calendar_weeks[takt_time.calendar_weeks.length-1]}`
          : ''
        }`
        "/>

        <TText v-else-if="takt_time" :size="15" :font_weight="isInTaktTime?'500':'300'" :text="`${ takt_time.first_day_string }.${ takt_time.dates[0].toISOString().substring(5,7) }.
        ${ takt_time.dates.length > 1
          ? ` - ${ takt_time.last_day_string}.${takt_time.dates[takt_time.dates.length - 1].toISOString().substring(5,7)}.`
          : ''
        }`"
      />
      <!-- NAVIGATE RIGHT -->
      <button
        v-if="$vuetify.breakpoint.smAndDown"
        class="wallet-takt-header-navigation-button"
        v-ripple
        @click.prevent.stop="$router.push({
          name: 'ProjectWalletTakt',
          params: {
            takt_index: parseInt($route.params.takt_index) + parseInt(1),
            direction: 'right',
          }
        })"
      >
        <TIcon name="chevron-right" large />
      </button>
    </slot>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import TIcon from '@/components/Taktify/TIcon.component.vue';

export default {

  components: {
    TIcon,
  },

  props: [
    'takt_time',
    'show_calendar_weeks',
  ],

  data: () => ({

  }),

  computed: {
    ...mapGetters('View',[
      'getUseOnSite'
    ]),
    isInTaktTime(){
      return this.takt_time && this.takt_time.dates[0].toISOString().substring(0,10) <= new Date().toISOString().substring(0,10) && this.takt_time.dates[this.takt_time.dates.length - 1].toISOString().substring(0,10) >= new Date().toISOString().substring(0,10)
    }
  },
}
</script>

<style>
.wallet-takt-header {
  display: flex;
  width: 100%;
  height: 50px;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  overflow: hidden;
  user-select: none;
  cursor: pointer;
  grid-gap: 4px;
  color: var(--v-primary-base);
}
.wallet-takt-header-statistic-button {
  position: absolute;
  left: 0px;
}
.wallet-takt-header-navigation-button {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
